export * from "-!../../../../node_modules/babel-loader/lib/index.js??ref--4-0!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./side-menu.vue?vue&type=template&id=2a5ed71f"


//////////////////
// WEBPACK FOOTER
// ./src/js/components/side-menu/side-menu.vue?vue&type=template&id=2a5ed71f
// module id = ./src/js/components/side-menu/side-menu.vue?vue&type=template&id=2a5ed71f
// module chunks = 4